import { PartnerSearchByBrResponse } from 'pco-product-service-internal-consumer';

export const getPartnerUid = (partner: PartnerSearchByBrResponse) => partner.techId;

export const getUniquePartnerUids = (partners: PartnerSearchByBrResponse[]) =>
  Array.from(new Set(partners.map(getPartnerUid).filter((uid): uid is string => !!uid)));

export const haveSamePartnerUids = (left: string[], right: string[]) => {
  if (left.length !== right.length) return false;
  const rightSet = new Set(right);
  return left.every((uid) => rightSet.has(uid));
};

export const getPartnerUidChanges = (initialPartnerUids: string[], selectedPartnerUids: string[]) => {
  const initialSet = new Set(initialPartnerUids);
  const selectedSet = new Set(selectedPartnerUids);
  return {
    addedPartnerUids: selectedPartnerUids.filter((uid) => !initialSet.has(uid)),
    removedPartnerUids: initialPartnerUids.filter((uid) => !selectedSet.has(uid)),
  };
};
